import React from 'react';
import { Center, Grid } from '@fiverr-private/layout_components';
import { useLandingPage } from '../../context/LandingPageContext';
import { SellerCard } from './SellerCard';

export const SellersSection = () => {
    const { staticSellers } = useLandingPage();

    return (
        <Center direction="column" gap="8" paddingY={{ default: '8', sm: '10' }} paddingX="8">
            <Grid templateColumns={{ lg: '33%_33%_33%', md: '50%_50%', default: '100%' }} gap="4">
                {staticSellers?.map((seller) => (
                    <SellerCard key={seller.displayName} {...seller} />
                ))}
            </Grid>
        </Center>
    );
};
